export default {
	name: 'AreaMangment',
	data() {
		return {
			search: '',
			clear: {},
			pageIndex: 1,
			pageRows: 10,
			count: 0,
			getData: {},
			areas: [],
			ShopID: this.$store.state.user.ShopID,
			areaID: 0,
			areaName: '',
			areaCode: '',
			Edit: '',
			clear: {}
		}
	},
	created() {
		this.clear = () => {

			this.areaID = 0;
			this.areaName = '';
			this.areaCode = '';
		}
		this.getData = () => {

			this.$request.request({
				url: 'Shops/getArea',
				data: {
					pageIndex: this.pageIndex,
					pageCount: this.pageRows,
					searchText: this.search
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.areas = r.areas;
					this.count = r.count;
					this.$store.dispatch('refresh');
				} else {
					this.$uil.showMessage({
						text: r.message
					});
				}
			})
		}


	},

	methods: {
		editArea() {
			this.$request.request({
				url: 'Shops/editarea',
				data: {
					areaCode: this.areaCode,
					areaID: this.areaID,
					areaName: this.areaName
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.getData();
					this.Edit = '';
				}
				this.$uil.showMessage({
					text: r.message
				});
			})


		},
		updateArea(i) {
			this.Edit = 'update';
			this.areaID = i.areaID;
			this.areaName = i.areaName;
			this.areaCode = i.areaCode;
		},

		changePages(s) {
			if (s == 'up') {
				if (this.pageIndex == 1)
					return;
				else
					this.pageIndex--;

			} else {
				if (this.pageIndex * this.pageRows >= this.count)
					return;
				else
					this.pageIndex++;
			}

			this.getData();
		},
		changePageRows() {
			if (this.pageIndex * this.pageRows >= this.count)
				this.pageIndex = 1;
			this.getData();
		}
	},
	computed: {
		checkbook() {
			return this.BooksName.length > 0 && this.BookBriefIntroduction.length > 0 && this.WriterName.length > 0 &&
				this.ClassificationID >
				0 && this.RecommendReason.length > 0 && this.BookRecommend.length > 0 && this.Tag.length > 0;
		},
		up() {
			if (this.pageIndex == 1)
				return true;
			else
				return false;
		},
		down() {
			if (this.pageIndex * this.pageRows >= this.count)
				return true;
			else
				return false;
		},
		page() {
			if (Math.ceil((this.count / this.pageRows)) == 0)
				return this.pageIndex + '/' + 1 + '页';
			else
				return this.pageIndex + '/' + Math.ceil((this.count / this.pageRows)) + '页';
		},
		checkArea() {
			if (this.areaName == '' || this.areaCode == "") return false;
			else return true;

		}
	},
	filters: {

	},
	activated() {
		this.getData();
	}

}
